export class SubscriptionAvailabilityModel {
public subscriptionAvailabiltiyHashId:string;
public sharedVehicleSubscriptionHashId:string;
public bookingStartTime:string
public bookingEndTime:string;
public startDay:string;
public endDay:string;
public subscriptionName:string;
public isChecked: boolean;
public startDayName:string;
public endDayName:string;
public isEditable : boolean;
public isDeletable : boolean;

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/subscriptionavailabilityrestriction/models/subscriptionavailabilityrestriction.model.ts